<template>
  <el-row :gutter="10">
    <el-col :span="10">
      <el-card style="height: 500px;overflow-y: auto;" :style="{ height: updateType === 'receipt' && uploadData.abnormalSign === 'N' ? '600px' : '500px'}" shadow="hover">
        <el-form size="mini" label-width="110px">
          <el-form-item label="单据类型" v-show="updateType !== 'waybill_fy' && updateType !== 'shortbill_fy' && updateType !== 'transfer_fy' && updateType !== 'delivery_fy' && updateType !== 'transaction_fy'">
            <el-input v-model="uploadData.module" disabled></el-input>
          </el-form-item>
          <el-form-item label="编号" v-show="updateType !== 'waybill_fy' && updateType !== 'shortbill_fy' && updateType !== 'transfer_fy' && updateType !== 'delivery_fy' && updateType !== 'transaction_fy'">
            <label slot="label">编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</label>
            <el-input v-model="uploadData.objectNo" disabled></el-input>
          </el-form-item>
          <el-form-item label="文件说明" v-show="updateType !== 'waybill_fy' && updateType !== 'shortbill_fy' && updateType !== 'transfer_fy' && updateType !== 'delivery_fy' && updateType !== 'transaction_fy'">
            <el-input v-model="uploadData.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="收货人签字日期" v-if="updateType === 'receipt' || updateType === 'transferHd' || updateType === 'shortbillHd' || updateType === 'deliveryHd'">
            <el-date-picker
                v-model="uploadData.signatureDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="签收单号" v-if="updateType === 'receipt' || updateType === 'transferHd' || updateType === 'shortbillHd' || updateType === 'deliveryHd'">
            <el-input v-model="uploadData.signNumber"></el-input>
          </el-form-item>
          <el-form-item label="签收状态" v-if="updateType === 'receipt' || updateType === 'transferHd' || updateType === 'shortbillHd' || updateType === 'deliveryHd'">
            <el-radio-group v-model="uploadData.abnormalSign" @change="abnormalSign_change">
              <el-radio label="Y">正常签收</el-radio>
              <el-radio label="N">异常签收</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="* 异常签收大类" v-if="updateType === 'receipt' && uploadData.abnormalSign === 'N'">
            <el-select style="width: 100%" v-model="uploadData.abnormalCategory" placeholder="请选择" clearable filterable @change="abnormalCategory_change">
              <el-option v-for="item in abnormalCategory_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="* 原因描述" v-show="updateType === 'receipt' && uploadData.abnormalCategory === '其他'">
            <el-input v-model="uploadData.reason" type="textarea" :autosize="{ minRows: 2, maxRows: 4}"></el-input>
          </el-form-item>
          <el-form-item label-width="80px">
            <el-upload
                class="upload-ali-demo"
                ref="refUploadAli"
                action
                :data="uploadData"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :auto-upload="false"
                accept=".jpg,.jpeg,.png,.pdf,.gif,.xls,.xlsx,.doc,.docx,.avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4,.mp3,.wma,.flac,.ape,.wav,.aac,.m4a"
                :before-upload="beforeAvatarUpload"
                multiple
                :on-exceed="handleExceed"
                :on-change="handleChange"
                :on-success="onSuccess"
                :on-error="onError"
                list-type="picture"
                :file-list="fileList">
              <!--:http-request="picUpload"-->
              <el-button slot="trigger" size="mini" type="primary" :style="editStatus ? 'display:none' : 'margin: 3px 5px;'" :disabled="onlySeeState" icon="el-icon-folder-opened">选择文件</el-button>
              <el-button :style="editStatus ? 'display:none;' : 'margin: 3px 5px;'" size="mini" type="info" @click="submitUpload" :disabled="onlySeeState" :loading="loading">开始上传</el-button>
              <el-button v-if="updateType !== 'waybill_fy' && updateType !== 'shortbill_fy' && updateType !== 'transfer_fy' && updateType !== 'delivery_fy' && updateType !== 'transaction_fy' && !onlySeeState" :style="!editStatus ? 'display:none;' : 'margin: 3px 5px;'" size="mini" type="info" @click="BeatMeterUpload" :loading="loading">拍照上传</el-button>
              <el-button v-if="updateType !== 'waybill_fy' && updateType !== 'shortbill_fy' && updateType !== 'transfer_fy' && updateType !== 'delivery_fy' && updateType !== 'transaction_fy' && !onlySeeState" style="margin: 3px 5px;" :type="editStatus ? 'danger' : 'success'" :loading="openLoading" size="mini" @click="openBeatMeter" icon="el-icon-camera">{{editStatus ? '关闭' : '拍照'}}</el-button>
              <el-button v-if="auditStatus === '2'" style="margin: 3px 5px;" type="danger" size="mini" @click="submitExamine">{{auditType === 'electron' ? '提交电子审核' : '提交纸质审核'}}</el-button>
              <!--              <el-button slot="trigger" size="mini" type="primary" icon="el-icon-upload2">点击上传</el-button>-->
            </el-upload>
          </el-form-item>
        </el-form>
        <template v-if="editStatus">
          <video id="videoMark" width="400px" height="250px" autoplay="autoplay"></video>
          <canvas id="canvasMark" style="display:none" width="3742" height="2806"></canvas>
        </template>
      </el-card>
    </el-col>
    <el-col :span="14">
      <el-card shadow="hover" style="height: 500px;overflow-y: auto;" :style="{ height: updateType === 'receipt' && uploadData.abnormalSign === 'N' ? '600px' : '500px'}" class="uploadali-el-card-style">
        <div slot="header" class="clearfix">
          <el-tabs v-model="tabActiveName" type="card" @tab-click="handleClick">
            <el-tab-pane label="上传资料" name="first"></el-tab-pane>
            <el-tab-pane label="历史上传资料" name="second"></el-tab-pane>
          </el-tabs>
          <el-button v-if="!validateNull(srcList) && tabActiveName === 'first' && (updateType === 'transferSign' || updateType === 'shortSign' || updateType === 'deliverySign')" style="float: left" size="mini" type="primary" @click="syncClick">同步运单</el-button>
          <el-button v-if="tabActiveName === 'first'" style="float: right;padding: 3px 0;font-size: 13px;" type="text" @click="batch_download">批量下载</el-button>
        </div>
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item name="picture">
            <template slot="title">
              图片 Picture<i class="header-icon el-icon-info"></i>
            </template>
            <div class="uploadImage" v-for="(item, index) in srcList" :key="item.url">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="item.url"
                  :preview-src-list="listString(srcList)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <!-- 遮罩层 -->
              <div class="optionMark" v-if="!onlySeeState && tabActiveName === 'first'">
                <div class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview">
                    <i class="el-icon-delete" @click="val => handlePictureCardRemove(item, index, val)"></i>
                  </span>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="file">
            <template slot="title">
              文件 File<i class="header-icon el-icon-info"></i>
            </template>
            <div v-for="(item, index) in fileSrcList" :key="item.url" class="file_download">
              <el-col :span="updateType === 'cusAberrant' ? 12 : 20" style="display: flex;justify-content: flex-start;align-items: center;">
                <img src="./file.png" alt="" style="width: 28px;">
                <span>{{item.fileName}}</span>
              </el-col>
              <el-col v-if="updateType === 'cusAberrant'" :span="8" style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;">
                <span style="font-size: 12px;color: #909399;">上传时间:{{item.createTime}}</span>
                <span style="font-size: 12px;color: #909399;">上传人:{{item.createUserName}}</span>
              </el-col>
              <el-col :span="4">
                <div class="file_download_delete">
                  <!--                <i style="margin-right: 20px; font-size: 14px;" class="el-icon-download" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                  <!--                <i style="font-size: 14px;" class="el-icon-delete" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                  <el-button style="margin-right: 10px;" type="primary" circle size="mini" icon="el-icon-download" title="下载" @click="val => handleFileDownload(item, index, val)"></el-button>
                  <el-button v-if="tabActiveName === 'first'" type="danger" circle size="mini" icon="el-icon-delete" title="删除" :disabled="onlySeeState" @click="val => handleFileDelete(item, index, val)"></el-button>
                </div>
              </el-col>
            </div>
          </el-collapse-item>
          <el-collapse-item name="video">
            <template slot="title">
              音频 Music/视频 Video<i class="header-icon el-icon-info"></i>
            </template>
            <!--            <img src="./music.png" alt="" style="width: 50px;">-->
            <!--            <div>音频 audio</div>-->
            <!--            <img src="./video.png" alt="" style="width: 50px;">-->
            <!--            <div>视频 video</div>-->
            <div v-for="(item, index) in videoSrcList" :key="item.url" class="file_download">
              <div v-if="item.fileType === 'video'">
                <el-col :span="20" style="display: flex;justify-content: flex-start;align-items: center;">
                  <img src="./video.png" alt="" style="width: 30px;">
                  <span>{{item.fileName}}</span>
                </el-col>
                <el-col :span="4">
                  <div class="file_download_delete">
                    <!--                <i style="margin-right: 20px; font-size: 14px;" class="el-icon-download" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                    <!--                <i style="font-size: 14px;" class="el-icon-delete" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                    <el-button style="margin-right: 10px;" type="primary" circle size="mini" icon="el-icon-download" title="下载" @click="val => handleVideoDownload(item, index, val)"></el-button>
                    <el-button type="danger" circle size="mini" icon="el-icon-delete" title="删除" @click="val => handleVideoDelete(item, index, val)"></el-button>
                  </div>
                </el-col>
              </div>
              <div v-if="item.fileType === 'music'">
                <el-col :span="20" style="display: flex;justify-content: flex-start;align-items: center;">
                  <img src="./music.png" alt="" style="width: 27px;margin-left: 2px;">
                  <span>{{item.fileName}}</span>
                </el-col>
                <el-col :span="4">
                  <div class="file_download_delete">
                    <!--                <i style="margin-right: 20px; font-size: 14px;" class="el-icon-download" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                    <!--                <i style="font-size: 14px;" class="el-icon-delete" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                    <el-button style="margin-right: 10px;" type="primary" circle size="mini" icon="el-icon-download" title="下载" @click="val => handleVideoDownload(item, index, val)"></el-button>
                    <el-button v-if="tabActiveName === 'first'" type="danger" circle size="mini" icon="el-icon-delete" title="删除" :disabled="onlySeeState" @click="val => handleVideoDelete(item, index, val)"></el-button>
                  </div>
                </el-col>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </el-col>
    <el-col :span="24">
      <!--选择图片同步运单-->
      <el-dialog custom-class="syncPicture_dialog" width="1120px" title="选择图片同步运单" v-if="syncPictureVisible" :visible.sync="syncPictureVisible" :close-on-click-modal="false" :show-close="false" append-to-body destroy-on-close>
        <el-timeline>
          <el-timeline-item timestamp="第一步：选择图片" placement="top">
            <div class="uploadImage" v-for="(item, index) in srcList" :key="item.url">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="item.url"
                  :preview-src-list="listString(srcList)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <el-checkbox-group v-model="checkedPictures">
              <el-checkbox style="width: 100px;text-align: center;margin: 2px 0 2px 17px;" v-for="item in srcList" :label="item.id" :key="item.id"></el-checkbox>
            </el-checkbox-group>
          </el-timeline-item>
          <el-timeline-item timestamp="第二步：选择要同步的运单" placement="top">
            <el-table border v-loading="syncLoading" :data="syncTableData" style="width: 100%" max-height="250" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="50" align="center"></el-table-column>
              <el-table-column prop="docDate" label="托运日期" width="100" align="center">
                <!--托运日期 格式显示保留到年月日-->
                <template slot-scope="scope">
                  <span>{{scope.row.docDate.slice(0,10)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ydNo" label="托运单号" width="150" align="center"></el-table-column>
              <el-table-column prop="fromCity" label="始发站" width="180" align="center"></el-table-column>
              <el-table-column prop="destCity" label="目的站" width="180" align="center"></el-table-column>
              <el-table-column prop="senderName" label="项目名称" width="150" align="center"></el-table-column>
              <el-table-column prop="zzAmount" label="出库金额" width="100" align="center"></el-table-column>
              <el-table-column prop="syncCount" label="同步图片数" width="100" align="center"></el-table-column>
            </el-table>
          </el-timeline-item>
        </el-timeline>
        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button type="primary" size="small" style="width: 80px" @click="submitSync">确认同步</el-button>
          <el-button type="info" size="small" style="width: 80px" @click="syncPictureVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>
<script>

import store from '@/store/index'
import {
  uploadAli,
  addUploadAli,
  delOssData,
  getOssObjectList,
  uploadAliAberrant,
  uploadAliQualifications,
  uploadAliConfirmationLetter,
  uploadAliCurrentInformation,
  getOssDeleteList,
  uploadAliConditionsResearch,
  uploadAliApprovalProfitLoss,
  uploadAliProjectKickoffMeeting
} from '@/api/basic/customer'
import { uploadAliLogistic } from '@/api/basic/logistic'
import { uploadAliTyd } from '@/api/tms/tmsyd'
import { uploadAliZzd, uploadAliDriverContract, getOssYdInfo, syncOssToHd, zzResubmit } from '@/api/tms/tmszz'
import { dtResubmit, uploadAliDt } from '@/api/tms/tmsdt'
import { uploadAliHd, hdResubmit, uploadAliCostHd } from '@/api/tms/tmshd'
import { addUploadAliFinace } from '@/api/tms/finacePayment'
import { addUploadAliSettle } from '@/api/tms/accsettle'
import { addUploadAliAccident } from '@/api/tms/tmssg'
import { addUploadAliAberrant } from '@/api/tms/tmstransaction'
import { uploadAliHy } from '@/api/tms/tmshy'
import { shResubmit, uploadAliSh } from '@/api/tms/tmssh'
import { uploadAliSalesInvoice, uploadAliSalesStatement, uploadAliSalesSignature, aliBatchSalesDownload } from '@/api/tms/accfp'
import { uploadAliIntroduce } from '@/api/basic/introduce'
import { uploadAliPerformance } from '@/api/tms/performancebond'
import { uploadAliDispatch } from '@/api/basic/dispatch'
import { uploadAliReceivableStatement, uploadAliReceivableSignature } from '@/api/tms/receivable'
import { uploadAliArtificial } from '@/api/tms/finaceDefrayment'
import { uploadAliPaymentCertificate, uploadAliPaymentReceipt } from '@/api/tms/bondaccount'
import { uploadProductPicture, uploadCoverPicture, uploadBiddingDocuments } from '@/api/basic/research'
import { uploadAliSalesRevenue } from '@/api/tms/salesRevenue'
import axios from 'axios'
import dayjs from 'dayjs'
import { validatenull } from '@/tdcommon/validate'
import { takePicture, dtaURItoBlob } from '@/tdcommon/beeutil'
import { uploadAliCy } from '@/api/tms/tmscy'
import { uploadAliSubproject } from '@/api/basic/subproject'
import { uploadAliTyre } from '@/api/basic/tyremanagement'
import { uploadAliRepair } from '@/api/basic/repairmanagement'
import { uploadAliCostManagement } from '@/api/basic/fleetCosts'
import { uploadAliInquiry } from '@/api/basic/inquirysheet'
import { uploadTenderContract } from '@/api/basic/customerTender'
import { uploadAliSubprojectQuotation } from '@/api/basic/subprojectQuotation'
import { uploadAliBidLoss } from '@/api/basic/bidProfitLoss'
import { uploadPriceTable } from '@/api/basic/supplierPriceReview'
import { uploadInsuranceFile } from '@/api/operation/insuranceLedger'

export default {
  name: 'd2-container-uploadAli',
  data () {
    return {
      loading: false,
      fileList: [],
      fileListMsg: [],
      formData: [],
      resultData: [],
      totalNumbers: 0,
      importNumbers: 0,
      filelistdata: {},
      uploadData: { module: this.customerType },
      headers: {
        'Authorization': 'Bearer ' + store.getters.access_token,
        'TENANT-ID': 1
      },
      uploadForm: [],
      tabActiveName: 'first',
      activeName: 'picture',
      // srcList: [
      //   'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
      //   'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      // ],
      srcList: [],
      fileSrcList: [],
      videoSrcList: [],
      updateNo: '',
      updateType: '',
      uploadStatus: false,
      editStatus: false, // 当前状态
      openLoading: false,
      auditStatus: '', // 上传审核状态
      auditText: '', // 已审核的文字提示
      auditType: '', // 回单管理（电子/纸质）
      updateId: '', // 回单ID
      uploadClassify: '', // 上传分类
      onlySeeState: false,
      // 选择图片同步运单
      syncPictureVisible: false,
      checkedPictures: [],
      syncCheckNum: 0,
      syncCheckSelect: [],
      syncLoading: false,
      syncTableData: [],
      abnormalCategory_options: [
        { value: '货物货损', label: '货物货损' },
        { value: '货物冻货', label: '货物冻货' },
        { value: '货物湿货', label: '货物湿货' },
        { value: '货差', label: '货差' },
        { value: '串货', label: '串货' },
        { value: '运输不及时', label: '运输不及时' },
        { value: '其他', label: '其他' }
      ]
    }
  },
  props: {
    // percentage: {
    //   type: Number,
    //   default: () => 0
    // },
    importVisible: {
      type: Boolean,
      default: () => false
    },
    uploadVisible: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    // url: {
    //   type: String,
    //   default: () => '/basic/dtcustomer/import/yyd'
    // },
    // customerNo: {
    //   type: String,
    //   default: () => ''
    // },
    customerType: {
      type: String,
      default: () => ''
    },
    docId: {
      type: Number,
      default: () => null
    },
    docType: {
      type: String,
      default: () => ''
    },
    costType: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    customerType: function (val, oldVal) {
      this.$set(this.uploadData, 'module', val)
    }
  },
  methods: {
    validateNull (val) {
      return validatenull(val)
    },
    abnormalSign_change (val) {
      if (val === 'Y') {
        this.$set(this.uploadData, 'abnormalCategory', '')
        this.$set(this.uploadData, 'reason', '')
      }
    },
    abnormalCategory_change (val) {
      if (val !== '其他') {
        this.$set(this.uploadData, 'reason', '')
      }
    },
    syncClick () {
      this.syncPictureVisible = true
      this.syncCheckNum = 0
      this.syncCheckSelect = []
      this.checkedPictures = []
      this.syncTableData = []
      this.syncLoading = true
      getOssYdInfo(Object.assign({
        docId: this.docId,
        docType: this.docType
      })).then(res => {
        if (res.code === 0) {
          this.syncTableData = res.data
          this.syncLoading = false
        } else {
          this.$message.error(res.msg)
          this.syncLoading = false
        }
      }).catch(() => {
        this.syncLoading = false
      })
    },
    // 打勾处理
    handleSelectionChange (selection) {
      if (selection.length === 0) {
        this.syncCheckNum = 0
      } else {
        this.syncCheckNum = selection.length
        this.syncCheckSelect = selection
      }
    },
    submitSync () {
      if (validatenull(this.checkedPictures)) {
        this.$message.error('请勾选要同步的图片！')
        return
      }
      if (this.syncCheckNum === 0) {
        this.$message.error('请勾选要同步的运单！')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在同步中，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 通过 Set 高效过滤
      const setA = new Set(this.checkedPictures)
      const ossObjectList = this.srcList.filter(item => setA.has(item.id))
      syncOssToHd(Object.assign({
        ossYdInfoVOList: this.syncCheckSelect,
        ossObjectList: ossObjectList
      })).then(res => {
        if (res.code === 0) {
          this.$message.success('同步成功！')
          this.syncPictureVisible = false
          loading.close()
        } else {
          this.$message.error(res.msg)
          loading.close()
        }
      }).catch(() => {
        loading.close()
      })
    },
    getActiveFirst (type) {
      this.activeName = type
    },
    handleClick () {
      if (this.tabActiveName === 'first') {
        this.getOssReturnData() // 调用返回数据接口
      } else if (this.tabActiveName === 'second') {
        this.getOssDeleteData() // 调用历史资料返回数据接口
      }
    },
    // 回单管理 重新提交审核
    async submitExamine () {
      let reviewType = this.auditType === 'electron' ? '1' : '2' // 提交审核类型（1：提交电子审核；2：提交纸质审核）
      let updateId = !validatenull(this.updateId) ? this.updateId : '' // 提交审核类型（1：提交电子审核；2：提交纸质审核）
      try {
        const res = await this.reSubmitMsg(updateId, reviewType)
        if (res.code === 0) {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.auditStatus = '0' // 初始化为 待审核
          if (this.updateType === 'receipt') {
            this.$emit('refreshClick') // 调父组件刷新表格时间
          }
        } else {
          this.$message.error(res.msg)
        }
      } catch (err) {

      }
      // hdResubmit(Object.assign({
      //   hdid: updateId,
      //   reviewType: reviewType
      // })).then(res => {
      //   if (res.code === 0) {
      //     this.$message({
      //       message: res.msg,
      //       type: 'success'
      //     })
      //     this.auditStatus = '0' // 初始化为 待审核
      //     this.$emit('refreshClick') // 调父组件刷新表格时间
      //   } else {
      //     this.$message.error(res.msg)
      //   }
      // })
      // this.$emit('refreshClick') // 调父组件刷新表格时间
    },
    reSubmitMsg (updateId, reviewType) {
      if (this.updateType === 'receipt') {
        return hdResubmit(Object.assign({ hdid: updateId, reviewType: reviewType }))
      } else if (this.updateType === 'transferHd') {
        return zzResubmit(Object.assign({ costId: updateId, reviewType: reviewType }))
      } else if (this.updateType === 'shortbillHd') {
        return dtResubmit(Object.assign({ costId: updateId, reviewType: reviewType }))
      } else if (this.updateType === 'deliveryHd') {
        return shResubmit(Object.assign({ costId: updateId, reviewType: reviewType }))
      }
    },
    // 上传
    async submitUpload () {
      this.loading = true
      if (!validatenull(this.fileListMsg)) { // 判断文件是否为空
        if (this.updateType === 'receipt' && this.uploadData.abnormalSign === 'N' && validatenull(this.uploadData.abnormalCategory)) {
          this.$message.error('回单异常签收，上传文件请先选择异常签收大类！')
          this.loading = false
          return
        }
        if (this.updateType === 'receipt' && this.uploadData.abnormalCategory === '其他' && validatenull(this.uploadData.reason)) {
          this.$message.error('异常签收大类选择“其他”，请填写原因描述！')
          this.loading = false
          return
        }
        if (this.auditStatus === '1') { // 判断上传是否已审核
          this.$message.error(this.auditText + '，不能更改！上传文件请先反审核！')
          this.loading = false
        } else {
          try {
            // 创建所有保存请求的Promise数组
            const promiseArr = this.fileListMsg.map(async (file) => {
              try {
                // 第一步：获取阿里云上传Sign
                const uploadSign = await this.getUploadAliSign()

                // 第二步：使用获取到的Sign上传文件
                var data = uploadSign.data
                var ossData = new FormData()
                let fileNamePoint = file.raw.name.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
                let fileNameLength = file.raw.name.length // 取到文件名长度
                let imgType = file.raw.name.substring(fileNamePoint + 1, fileNameLength).toLocaleLowerCase() // 截  所有后缀格式转小写
                var fileName = this.updateNo + Math.random().toString().substr(2, 3) + file.raw.name // 上传阿里保存 文件名=单位编码+3位随机码+原有文件名
                let keyValue = data.dir + fileName
                ossData.append('name', fileName)
                ossData.append('key', keyValue)
                ossData.append('policy', data.policy)
                ossData.append('OSSAccessKeyId', data.accessid)
                ossData.append('success_action_status', 200)
                ossData.append('signature', data.signature)
                ossData.append('callback', data.callback)
                ossData.append('file', file.raw, file.raw.name)
                const uploadResult = await this.uploadAliMsg(data, ossData)

                if (uploadResult.status === 200) {
                  let fileType = ''
                  if (imgType === 'jpg' || imgType === 'jpeg' || imgType === 'png' || imgType === 'gif') { // .jpg,.jpeg,.png,.gif
                    fileType = 'picture'
                  } else if (imgType === 'xls' || imgType === 'xlsx' || imgType === 'doc' || imgType === 'docx' || imgType === 'pdf') { // xls,.xlsx,.doc,.docx,.pdf
                    fileType = 'file'
                  } else if (imgType === 'avi' || imgType === 'wmv' || imgType === 'mpeg' || imgType === 'mov' || imgType === 'rm' || imgType === 'rmvb' || imgType === 'flv' || imgType === 'mkv' || imgType === 'mp4') { // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
                    fileType = 'video'
                  } else if (imgType === 'mp3' || imgType === 'wma' || imgType === 'flac' || imgType === 'ape' || imgType === 'wav' || imgType === 'aac' || imgType === 'm4a') { // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
                    fileType = 'music'
                  }
                  // 第三步：使用获取到的URL保存到后台
                  const saveResult = await this.saveUploadAli(keyValue, fileName, fileType)
                  return saveResult
                }
              } catch (error) {
                // 如果单个文件失败，抛出错误，让 Promise.all 能够捕获
                // throw new Error(`上传保存文件 ${file.raw.name} 失败: ${error.message}`)
                this.$notify.error({
                  title: '错误',
                  message: `上传保存文件 ${file.raw.name} 失败: ${error.message}`
                })
                // this.$message.error(`上传保存文件 ${file.raw.name} 失败: ${error.message}`)
              }
            })
            console.log('promiseArr', promiseArr)
            // 等待所有保存请求完成（各文件独立执行，互不影响）
            const saveResults = await Promise.all(promiseArr)
            this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
            this.fileListMsg = [] // 清空handlechange的文件缓存
            // 保存接口返回 code === 1 视为该文件保存失败：仅提示该文件错误，其余文件继续执行
            const errorResults = saveResults.filter(r => r && Number(r.code) === 1)
            const successResults = saveResults.filter(r => r && Number(r.code) !== 1)
            errorResults.forEach(r => this.$message.error(r.msg || '上传保存失败'))
            if (successResults.length === 0) {
              return
            }
            if (this.updateType === 'receipt' || this.updateType === 'repaymanage' || this.updateType === 'receiptpayment' || this.updateType === 'accident' || this.updateType === 'accidentAr' || this.updateType === 'accidentAp' || this.updateType === 'accidentCase' || this.updateType === 'aberrant' || this.updateType === 'supply' || this.updateType === 'salesApplication' || this.updateType === 'salesStatement' || this.updateType === 'salesSignature' || this.updateType === 'receivableStatement' || this.updateType === 'receivableSignature' || this.updateType === 'defrayment' || this.updateType === 'paymentCertificate' || this.updateType === 'paymentReceipt' || this.updateType === 'productPicture' || this.updateType === 'coverPicture' || this.updateType === 'biddingDocuments' || this.updateType === 'salesRevenue' || this.updateType === 'subproject' || this.updateType === 'subprojectQuotation' || this.updateType === 'repairmanagement' || this.updateType === 'tyremanagement' || this.updateType === 'fleetCosts' || this.updateType === 'inquirysheet' || this.updateType === 'customerTender') {
              this.$emit('refreshClick') // 调父组件刷新表格时间
            }
            if (this.updateType === 'waybill_fy' || this.updateType === 'transfer_fy' || this.updateType === 'shortbill_fy' || this.updateType === 'delivery_fy' || this.updateType === 'transaction_fy') { // 费用明细（托运单、短驳单、中转单、送货单）
              this.$emit('afterUpload')
            }
            // 所有保存完成后，调用查询接口
            await this.getOssReturnData()
            this.$message.success('上传成功！')
          } catch (error) {
            console.error('上传失败:', error)
            // this.$message.error('上传失败' + error)
            this.$notify.error({
              title: '错误',
              message: '上传失败' + error
            })
          } finally {
            console.error('上传finally')
            this.loading = false
          }
        }
      } else {
        this.$message.error('请选择上传文件！')
        this.loading = false
      }
    },
    // 获取上传Sign
    getUploadAliSign () {
      console.log('获取上传Sign')
      return uploadAli()
    },
    // 上传文件
    uploadAliMsg (data, ossData) {
      console.log('上传文件')
      return axios.post(data.host, ossData, { headers: { 'Content-Type': 'multipart/form-data' } })
    },
    // 保存到后台
    saveUploadAli (keyValue, fileName, fileType) {
      console.log('保存到后台')
      if (this.updateType === 'forwarding') { // 发货单位
        return addUploadAli(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'carrier') { // 承运单位、合同、培训资料上传
        return uploadAliLogistic(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'supplierPriceReview') { // 供应商价格审核 价格表上传（保存接口后端待提供，已预留）
        return uploadPriceTable(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型 价格表分类：GYSJGSY上游价格表、GYSJGCB项目组测算成本、GYSJGXY下游价格表
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'insuranceLedger') { // 保险台账 单证资料/回款核销上传（保存接口 /tms/ossobject/tmsInsuranceLedgerTrackUpload）
        return uploadInsuranceFile(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 关联号 INSURANCE_LEDGER_台账id
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为上传类型名称
          itemType: this.uploadClassify, // 类型 直接传中文（如 事故认定书、各级运输合同、保险回款核销）
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'waybill' || this.updateType === 'collectionBudget_second') { // 托运单
        return uploadAliTyd(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'waybill_fy' || this.updateType === 'transfer_fy' || this.updateType === 'shortbill_fy' || this.updateType === 'delivery_fy' || this.updateType === 'transaction_fy') { // 费用明细（托运单、短驳单、中转单、送货单）
        return uploadAliTyd(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'transfer' || this.updateType === 'transferSign') { // 中转单、中转签收单
        return uploadAliZzd(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'shortbill' || this.updateType === 'shortSign') { // 短驳单、短驳签收单
        return uploadAliDt(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'delivery' || this.updateType === 'deliverySign') { // 送货单、送货签收单
        return uploadAliSh(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'receipt') { // 回单管理
        return uploadAliHd(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc, // 文件说明
          signatureDate: this.uploadData.signatureDate, // 收货人签字日期
          signNumber: this.uploadData.signNumber, // 签收单号
          abnormalSign: this.uploadData.abnormalSign, // 异常签收
          abnormalCategory: this.uploadData.abnormalCategory, // 异常签收大类
          reason: this.uploadData.reason // 异常签收原因
        }))
      } else if (this.updateType === 'repaymanage') { // 请款管理
        return addUploadAliFinace(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'receiptpayment') { // 收款付款
        return addUploadAliSettle(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'accident' || this.updateType === 'accidentAr' || this.updateType === 'accidentAp' || this.updateType === 'accidentCase') { // 事故上传
        return addUploadAliAccident(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'aberrant') { // 异动上传
        return addUploadAliAberrant(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'supply') { // 货源上传
        return uploadAliHy(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'salesApplication') { // 销项发票申请单上传
        return uploadAliSalesInvoice(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'salesStatement') { // 销项发票对账单上传
        return uploadAliSalesStatement(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'salesSignature') { // 销项发票签收单上传
        return uploadAliSalesSignature(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'driverContract') { // 中转单 纸质合同上传
        return uploadAliDriverContract(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'introduce') { // 立项报告 上传
        return uploadAliIntroduce(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'bidProfitLoss') { // 中标损益 上传
        return uploadAliBidLoss(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'cusAberrant') { // 项目管理 合同 上传
        return uploadAliAberrant(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'qualifications') { // 项目管理 客户资质 上传
        return uploadAliQualifications(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'confirmationLetter') { // 项目管理 确认函 上传
        return uploadAliConfirmationLetter(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'currentInformation') { // 项目管理 往来资料 上传
        return uploadAliCurrentInformation(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'conditionsResearch') { // 项目管理 三情调研 上传
        return uploadAliConditionsResearch(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'approvalProfitLoss') { // 项目管理 立项损益 上传
        return uploadAliApprovalProfitLoss(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'conferenceInformation') { // 项目管理 项目启动会议资料 上传
        return uploadAliProjectKickoffMeeting(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'performance') { // 履约保证金 收据 上传
        return uploadAliPerformance(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'dispatch') { // 调度档案 上传
        return uploadAliDispatch(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'receivableStatement') { // 应收账单 对账单上传
        return uploadAliReceivableStatement(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'receivableSignature') { // 应收账单 签收单上传
        return uploadAliReceivableSignature(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'defrayment') { // 人工成本
        return uploadAliArtificial(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'paymentCertificate') { // 保证金台账 付款凭证上传
        return uploadAliPaymentCertificate(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'paymentReceipt') { // 保证金台账 收款收据上传
        return uploadAliPaymentReceipt(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'productPicture') { // 调研报告上传产品图片
        return uploadProductPicture(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'coverPicture') { // 调研报告上传装车封面图片
        return uploadCoverPicture(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'biddingDocuments') { // 调研报告上传招标文件
        return uploadBiddingDocuments(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'salesRevenue') { // 销售收入分配
        return uploadAliSalesRevenue(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'difference') { // 差异管理
        return uploadAliCy(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'subproject') { // 子项目合同
        return uploadAliSubproject(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'subprojectQuotation') { // 子项目报价单合同
        return uploadAliSubprojectQuotation(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'repairmanagement') { // 维修管理
        return uploadAliRepair(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'tyremanagement') { // 轮胎管理
        return uploadAliTyre(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'fleetCosts') { // 车队费用管理
        return uploadAliCostManagement(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'inquirysheet') { // 成本询价
        return uploadAliInquiry(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'customerTender') { // 项目详情 招标合同
        return uploadTenderContract(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'transferHd' || this.updateType === 'shortbillHd' || this.updateType === 'deliveryHd') { // 中转单、短驳单、送货单 上传回单
        return uploadAliCostHd(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          fileDesc: this.uploadData.fileDesc, // 文件说明
          costType: this.costType, // 成本单类型
          signatureDate: this.uploadData.signatureDate, // 收货人签字日期
          signNumber: this.uploadData.signNumber, // 签收单号
          abnormalSign: this.uploadData.abnormalSign // 异常签收
        }))
      }
    },
    async picUpload (file) {
      uploadAli().then(response => {
        // console.log('uploadAli', response)
        var data = response.data
        var ossData = new FormData()
        // var imgType = file.raw.name.split('.')[1]
        let fileNamePoint = file.raw.name.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
        let fileNameLength = file.raw.name.length // 取到文件名长度
        let imgType = file.raw.name.substring(fileNamePoint + 1, fileNameLength).toLocaleLowerCase() // 截  所有后缀格式转小写
        // console.log('fileName', fileNamePoint + 1)
        // console.log('fileNameLength', fileNameLength)
        // console.log('imgType', imgType)
        // var fileName = this.updateNo + '_' + dayjs(new Date()).format('YYYYMMDDHHmmssSSS') + Math.random().toString().substr(2, 4) + '.' + imgType // 上传阿里保存 文件名=单位编码+日期（年月日时分秒+毫秒3位数）+4位随机码+文件类型
        var fileName = this.updateNo + Math.random().toString().substr(2, 3) + file.raw.name // 上传阿里保存 文件名=单位编码+3位随机码+原有文件名
        ossData.append('name', fileName)
        // key就代表文件层级和阿里云上的文件名
        // let filename = file.file.name + file.file.size
        // let keyValue = data.dir + '/' + filename + '.' + imgType
        let keyValue = data.dir + fileName
        ossData.append('key', keyValue)
        ossData.append('policy', data.policy)
        ossData.append('OSSAccessKeyId', data.accessid)
        ossData.append('success_action_status', 200)
        ossData.append('signature', data.signature)
        ossData.append('callback', data.callback)
        ossData.append('file', file.raw, file.raw.name)
        axios.post(data.host, ossData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          let fileType = ''
          if (imgType === 'jpg' || imgType === 'jpeg' || imgType === 'png' || imgType === 'gif') { // .jpg,.jpeg,.png,.gif
            fileType = 'picture'
          } else if (imgType === 'xls' || imgType === 'xlsx' || imgType === 'doc' || imgType === 'docx' || imgType === 'pdf') { // xls,.xlsx,.doc,.docx,.pdf
            fileType = 'file'
          } else if (imgType === 'avi' || imgType === 'wmv' || imgType === 'mpeg' || imgType === 'mov' || imgType === 'rm' || imgType === 'rmvb' || imgType === 'flv' || imgType === 'mkv' || imgType === 'mp4') { // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
            fileType = 'video'
          } else if (imgType === 'mp3' || imgType === 'wma' || imgType === 'flac' || imgType === 'ape' || imgType === 'wav' || imgType === 'aac' || imgType === 'm4a') { // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
            fileType = 'music'
          }
          if (res.status === 200) {
            // let url = data.host // 上传阿里保存 传值URL
            if (this.updateType === 'forwarding') { // 发货单位
              addUploadAli(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'carrier') { // 承运单位、合同、资质上传
              uploadAliLogistic(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'waybill') { // 托运单
              uploadAliTyd(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'waybill_fy' || this.updateType === 'transfer_fy' || this.updateType === 'shortbill_fy' || this.updateType === 'delivery_fy' || this.updateType === 'transaction_fy') { // 费用明细（托运单、短驳单、中转单、送货单）
              uploadAliTyd(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$nextTick(() => {
                    this.$emit('afterUpload')
                  })
                }
              })
            } else if (this.updateType === 'transfer' || this.updateType === 'transferSign') { // 中转单、中转签收单
              uploadAliZzd(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'shortbill' || this.updateType === 'shortSign') { // 短驳单、短驳签收单
              uploadAliDt(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'delivery' || this.updateType === 'deliverySign') { // 送货单、送货签收单
              uploadAliSh(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'receipt') { // 回单管理
              uploadAliHd(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc, // 文件说明
                signatureDate: this.uploadData.signatureDate, // 收货人签字日期
                signNumber: this.uploadData.signNumber, // 签收单号
                abnormalSign: this.uploadData.abnormalSign // 异常签收
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'repaymanage') { // 请款管理
              addUploadAliFinace(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'receiptpayment') { // 收款付款
              addUploadAliSettle(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'accident' || this.updateType === 'accidentAr' || this.updateType === 'accidentAp' || this.updateType === 'accidentCase') { // 事故上传
              addUploadAliAccident(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'aberrant') { // 异动上传
              addUploadAliAberrant(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'supply') { // 货源上传
              uploadAliHy(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'salesApplication') { // 销项发票申请单上传
              uploadAliSalesInvoice(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'salesStatement') { // 销项发票对账单上传
              uploadAliSalesStatement(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'salesSignature') { // 销项发票签收单上传
              uploadAliSalesSignature(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'driverContract') { // 中转单 纸质合同上传
              uploadAliDriverContract(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'introduce') { // 立项报告 上传
              uploadAliIntroduce(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'bidProfitLoss') { // 中标损益 上传
              uploadAliBidLoss(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'cusAberrant') { // 项目管理 合同 上传
              uploadAliAberrant(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'qualifications') { // 项目管理 客户资质 上传
              uploadAliQualifications(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'confirmationLetter') { // 项目管理 确认函 上传
              uploadAliConfirmationLetter(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'currentInformation') { // 项目管理 往来资料 上传
              uploadAliCurrentInformation(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'performance') { // 履约保证金 收据 上传
              uploadAliPerformance(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'dispatch') { // 调度档案 上传
              uploadAliDispatch(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'receivableStatement') { // 应收账单 对账单上传
              uploadAliReceivableStatement(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'receivableSignature') { // 应收账单 签收单上传
              uploadAliReceivableSignature(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'defrayment') { // 人工成本
              uploadAliArtificial(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'paymentCertificate') { // 保证金台账 付款凭证上传
              uploadAliPaymentCertificate(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'paymentReceipt') { // 保证金台账 收款收据上传
              uploadAliPaymentReceipt(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'productPicture') { // 调研报告上传产品图片
              uploadProductPicture(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'coverPicture') { // 调研报告上传装车封面图片
              uploadCoverPicture(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'biddingDocuments') { // 调研报告上传招标文件
              uploadBiddingDocuments(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'salesRevenue') { // 销售收入分配
              uploadAliSalesRevenue(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'difference') { // 差异管理
              uploadAliCy(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                }
              })
            } else if (this.updateType === 'subproject') { // 子项目合同
              uploadAliSubproject(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'subprojectQuotation') { // 子项目报价单合同
              uploadAliSubprojectQuotation(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'repairmanagement') { // 维修管理
              uploadAliRepair(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'tyremanagement') { // 轮胎管理
              uploadAliTyre(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'fleetCosts') { // 车队费用管理
              uploadAliCostManagement(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'inquirysheet') { // 成本询价
              uploadAliInquiry(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            } else if (this.updateType === 'customerTender') { // 项目详情 招标合同
              uploadTenderContract(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            }
          }
        }).catch(() => {
        })
      })
    },
    handleChange (file, fileList) {
      this.fileListMsg = fileList
    },
    handleRemove (file, fileList) {
    },
    handlePreview (file, fileList) {
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 高拍仪拍照上传
    BeatMeterUpload () {
      if (takePicture('videoMark', 'canvasMark', 'take', this)) {
        this.loading = true
        const tempSrc = document.getElementById('canvasMark')
        const base64Data = tempSrc.toDataURL('image/jpeg', 1.0)
        let blob = dtaURItoBlob(base64Data)
        blob.lastModifiedDate = new Date()
        blob.name = this.updateNo + '_' + dayjs(new Date()).format('YYYYMMDDHHmmssSSS') + Math.random().toString().substr(2, 4) + '.jpeg'
        var fd = { name: blob.name, percentage: 0, raw: blob, size: blob.size, status: 'ready' }
        // this.picUpload(fd)
        this.fileListMsg = []
        this.fileListMsg.push(fd)
        setTimeout(() => {
          this.submitUpload()
        }, 0)
      }
    },
    // 高拍仪设备操作
    openBeatMeter () {
      this.openLoading = true
      if (!validatenull(this.fileListMsg)) {
        this.$message.warning('请先将选择文件进行上传或删除后，再进行开启拍摄功能')
        this.openLoading = false
        return
      }
      if (!this.editStatus) {
        this.editStatus = true
        setTimeout(() => {
          takePicture('videoMark', 'canvasMark', 'open', this)
          setTimeout(() => {
            this.openLoading = false
          }, 1500)
        }, 500)
      } else {
        takePicture('videoMark', 'canvasMark', 'close', this)
        setTimeout(() => {
          this.editStatus = false
          this.openLoading = false
        }, 500)
      }
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 判断导入的格式是不是xls、xlsx、...，如果不是则提示
    beforeAvatarUpload (file, fileList) {
      const isIMAGE = file.type === '.jpg' || '.jpeg' || '.png' || '.gif' // .jpg,.jpeg,.png,.gif
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isFile = testmsg === '.xls' || '.xlsx' || '.doc' || '.docx' || '.pdf'
      const isVideo = testmsg === '.avi' || '.wmv' || '.mpeg' || '.mov' || '.rm' || '.rmvb' || '.flv' || '.mkv' || '.mp4' // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
      const isMusic = testmsg === '.mp3' || '.wma' || '.flac' || '.ape' || '.wav' || '.aac' || '.m4a' // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
      const isLt2M = file.size / 1024 / 1024 < 50

      if (!isFile || !isVideo || !isMusic || !isIMAGE) {
        this.$message.error('上传文件格式不支持！')
        return false
      }
      // if (!isIMAGE) {
      //   this.$message.error('上传文件只能是图片格式!')
      // }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 50MB!')
      }
      return (isIMAGE || isFile || isVideo || isMusic) && isLt2M
      // return isIMAGE
    },
    // 上传成功
    onSuccess (res, file, fileList) {
      // let val = ''
      // fileList.forEach(item => {
      //   if (val !== '') {
      //     val += ','
      //   }
      //   if (item.response) {
      //     val += item.response.data.downloadPath
      //   } else {
      //     val += item.url
      //   }
      // })
      // this.$emit('input', val)
      // this.uploadAliyun(res, file)
    },
    // 上传失败
    onError () {
    },
    // 获取客户编号
    getupdateNo (cusNo, type, auditStatus, classify, auditText, auditType, updateId, signatureDate, signNumber, abnormalSign, abnormalCategory, reason) {
      this.tabActiveName = 'first'
      this.updateNo = cusNo
      this.updateType = type
      this.auditStatus = auditStatus // 上传审核状态（'1'为已审核，'0'为未审核，'2'为不通过）
      this.uploadClassify = classify // 上传分类
      this.auditText = auditText // 已审核的文字提示
      this.auditType = auditType // 回单管理（电子/纸质）
      this.updateId = updateId // 回单ID
      this.$set(this.uploadData, 'objectNo', cusNo)
      if (type === 'receipt' || type === 'transferHd' || type === 'shortbillHd' || type === 'deliveryHd') {
        this.$set(this.uploadData, 'signatureDate', !validatenull(signatureDate) ? signatureDate : '')
        this.$set(this.uploadData, 'signNumber', !validatenull(signNumber) ? signNumber : '')
        this.$set(this.uploadData, 'abnormalSign', !validatenull(abnormalSign) ? abnormalSign : 'Y')
      }
      if (type === 'receipt') {
        this.$set(this.uploadData, 'abnormalCategory', !validatenull(abnormalCategory) ? abnormalCategory : '')
        this.$set(this.uploadData, 'reason', !validatenull(reason) ? reason : '')
      }
    },
    // 只查看附件 调取事件
    getOssOnlySee (status) {
      this.onlySeeState = status
    },
    // 关闭时清空srclist
    clearSrcList () {
      this.srcList = []
      this.fileSrcList = []
      this.videoSrcList = []
      if (this.editStatus) {
        takePicture('videoMark', 'canvasMark', 'close', this)
        this.editStatus = false
        this.openLoading = false
      }
      this.$set(this.uploadData, 'objectNo', '') // 清空编号
      this.$set(this.uploadData, 'fileDesc', '') // 清空文件说明
      if (this.updateType === 'receipt' || this.updateType === 'transferHd' || this.updateType === 'shortbillHd' || this.updateType === 'deliveryHd') {
        this.$set(this.uploadData, 'signatureDate', '') // 清空收货人签字日期
        this.$set(this.uploadData, 'signNumber', '') // 清空签收单号
        this.$set(this.uploadData, 'abnormalSign', '') // 清空签收状态
      }
      if (this.updateType === 'receipt') {
        this.$set(this.uploadData, 'abnormalCategory', '') // 异常签收大类
        this.$set(this.uploadData, 'reason', '') // 异常签收原因
      }
      this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
    },
    listString (imageList) {
      var imageArray = []
      imageList.forEach(item => {
        imageArray.push(item.url)
      })
      return imageArray
    },
    // 获取上传返回的数据
    getOssReturnData () {
      const loading = this.$loading({
        lock: true,
        text: '正在加载中，请稍等。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.loading = true
      this.tabActiveName = 'first' // 上传后 切换
      getOssObjectList(Object.assign({
        objectNo: this.updateNo,
        itemType: this.uploadClassify
      })).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.srcList = []
          this.fileSrcList = []
          this.videoSrcList = []
          if (validatenull(res.data)) {
            loading.close()
            this.setDefaultActive()
            return
          }
          res.data.forEach(urls => {
            // let option = {}
            // option.id = urls.id
            // option.url = urls.url
            // option.fileName = urls.fileName
            // option.itemType = urls.itemType
            // option.fileType = urls.fileType
            // option.createUserName = urls.createUserName
            // option.createTime = urls.createTime
            if (urls.fileType === 'picture') {
              this.srcList.push(urls)
            } else if (urls.fileType === 'file') {
              this.fileSrcList.push(urls)
            } else if (urls.fileType === 'video' || urls.fileType === 'music') {
              this.videoSrcList.push(urls)
            }
          })
          setTimeout(() => {
            loading.close()
            this.setDefaultActive()
          }, 500)
        } else {
          this.srcList = []
          this.fileSrcList = []
          this.videoSrcList = []
          loading.close()
          this.setDefaultActive()
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.srcList = []
        this.fileSrcList = []
        this.videoSrcList = []
        loading.close()
        this.setDefaultActive()
        this.loading = false
      })
    },
    // 获取上传删除后的历史资料返回的数据
    getOssDeleteData () {
      const loading = this.$loading({
        lock: true,
        text: '正在加载中，请稍等。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.loading = true
      getOssDeleteList(Object.assign({
        objectNo: this.updateNo,
        itemType: this.uploadClassify
      })).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.srcList = []
          this.fileSrcList = []
          this.videoSrcList = []
          if (validatenull(res.data)) {
            loading.close()
            this.setDefaultActive()
            return
          }
          res.data.forEach(urls => {
            // let option = {}
            // option.id = urls.id
            // option.url = urls.url
            // option.fileName = urls.fileName
            // option.itemType = urls.itemType
            // option.fileType = urls.fileType
            if (urls.fileType === 'picture') {
              this.srcList.push(urls)
            } else if (urls.fileType === 'file') {
              this.fileSrcList.push(urls)
            } else if (urls.fileType === 'video' || urls.fileType === 'music') {
              this.videoSrcList.push(urls)
            }
          })
          setTimeout(() => {
            loading.close()
            this.setDefaultActive()
          }, 500)
        } else {
          this.srcList = []
          this.fileSrcList = []
          this.videoSrcList = []
          loading.close()
          this.setDefaultActive()
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.srcList = []
        this.fileSrcList = []
        this.videoSrcList = []
        loading.close()
        this.setDefaultActive()
        this.loading = false
      })
    },
    setDefaultActive () {
      if (!validatenull(this.srcList)) {
        this.activeName = 'picture'
      } else if (!validatenull(this.fileSrcList)) {
        this.activeName = 'file'
      } else if (!validatenull(this.videoSrcList)) {
        this.activeName = 'video'
      } else {
        this.activeName = 'picture'
      }
    },
    // 预览返回图片
    handlePictureCardPreview (file) {
      // this.$refs.image_refs.clickHandler()
    },
    // 删除返回图片
    handlePictureCardRemove (option, index, val) {
      if (this.auditStatus === '1') {
        this.$message.error(this.auditText + '，不能更改！删除图片请先反审核！')
      } else {
        delOssData(option.id).then(item => {
          if (item.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.srcList.splice(index, 1) // 前端页面移除
          } else {
            this.$message.error(item.msg)
          }
        })
      }
    },
    batch_download () {
      const loading = this.$loading({
        lock: true,
        text: '正在下载中，请稍等。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      aliBatchSalesDownload(Object.assign({
        objectNo: this.uploadData.objectNo,
        itemType: this.uploadClassify
      })).then(response => {
        let blob = new Blob([response], { type: 'application/zip' })
        let url = window.URL.createObjectURL(blob)
        const link = document.createElement('a') // 创建a标签
        link.href = url
        link.download = this.customerType + this.updateNo // 重命名文件
        link.click()
        URL.revokeObjectURL(url) // 释放内存
        setTimeout(() => {
          loading.close()
        }, 2000)
      })
    },
    // 下载返回文件
    handleFileDownload (option, index, val) {
      let fileNamePoint = option.fileName.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
      let fileNameLength = option.fileName.length // 取到文件名长度
      let imgType = option.fileName.substring(fileNamePoint + 1, fileNameLength) // 截

      if (imgType === 'pdf') { // 如果文件类型是pdf
        window.open(option.url)
      } else { // 如果是其他文件类型
        const ele = document.createElement('a')
        ele.setAttribute('href', option.url) // 设置下载文件的url地址
        ele.setAttribute('download', option.fileName) // 用于设置下载文件的文件名
        ele.click()
      }
    },
    // 下载返回音频、视频
    handleVideoDownload (option, index, val) {
      // const ele = document.createElement('a')
      // ele.setAttribute('href', option.url) // 设置下载文件的url地址
      // ele.setAttribute('download', option.fileName) // 用于设置下载文件的文件名
      // ele.click()
      // 将lob对象转换为域名结合式的url
      // const link = document.createElement('a')
      // link.style.display = 'none'
      // // 设置a标签的下载属性，设置文件名及格式，后缀名最好让后端在数据格式中返回
      // link.download = option.fileName
      // var blob = new Blob(option.url)
      // link.href = URL.createObjectURL(blob)
      // // 自触发click事件
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      window.open(option.url)
    },
    // 删除返回文件
    handleFileDelete (option, index, val) {
      if (this.auditStatus === '1') {
        this.$message.error(this.auditText + '，不能更改！删除文件请先反审核！')
      } else {
        delOssData(option.id).then(item => {
          if (item.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.fileSrcList.splice(index, 1) // 前端页面移除
          } else {
            this.$message.error(item.msg)
          }
        })
      }
    },
    // 删除返回音频、视频
    handleVideoDelete (option, index, val) {
      if (this.auditStatus === '1') {
        this.$message.error(this.auditText + '，不能更改！删除音频、视频请先反审核！')
      } else {
        delOssData(option.id).then(item => {
          if (item.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.videoSrcList.splice(index, 1) // 前端页面移除
          } else {
            this.$message.error(item.msg)
          }
        })
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.uploadali-el-card-style {
    .el-card__header {
        padding: 14px 20px !important;
        border-bottom: 0 !important;
    }
    .el-upload-list {
      max-height: 233px;
      overflow-y: auto;
    }
}
.uploadImage {
    position: relative;
    display: inline-block;
    margin-left: 17px;
    .optionMark {
        display: none;
        position: absolute;
        width: 50px;
        height: 50px;
        left: 50px;
        top: 50px;
        background:linear-gradient(to top left,rgba(0,0,0,.5) 40%,transparent 40%);

        .el-upload-list__item-actions {
            position: absolute;
            font-size: 15px;
            left: 6px;
            top: 26px;
            width: 100%;
            height: 100%;
            text-align: right;
            color: #fff;
            transition: opacity .3s;
        }
    }
}
.uploadImage:hover {
    .optionMark {
        display: block;
        z-index: 999;
        .el-upload-list__item-preview {
            cursor: pointer;
        }
    }
}
.file_download {
  display: flex;
  justify-content: center;
  align-items: center;
  //border-bottom: 1px solid #EBEEF5;
}
/*文件下载删除 鼠标移入样式改变*/
.file_download:hover{
    cursor: pointer;
    .file_download_delete{display: block};
}
/*文件下载删除按钮*/
.file_download_delete{
  display: none;
}
.syncPicture_dialog {
  border-radius: 12px;
  .el-dialog__body {
    padding: 20px 40px 20px 0;
    .el-table-column--selection .cell {
      padding-right: 10px;
    }
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-uploadAli/index.vue"
}
</vue-filename-injector>
